import React from 'react';
import useInbox from '../../../api/panel/inbox';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function NotificationsList() {
    // Popup shows unread only; the full history lives on the notifications page.
    const { inbox, markRead, markAll } = useInbox({ page: 1, limit: 20, unreadOnly: true });

    const items = inbox.data?.data || [];
    const loading = inbox.isLoading;
    const hasUnread = items.some((i) => !i.read);

    if (loading) return <div className="p-3 text-muted">Loading…</div>;

    return (
        <div className="card">
            <div className="card-header d-flex align-items-center">
                <strong>Notifications</strong>
                {hasUnread && (
                    <button
                        className="btn btn-outline-secondary btn-sm ms-auto"
                        onClick={() => markAll.mutate()}
                        disabled={markAll.isLoading}
                    >
                        Mark all read
                    </button>
                )}
            </div>
            <ul className="list-group list-group-flush">
                {items.length === 0 && (
                    <li className="list-group-item text-muted small text-center py-3">No unread notifications</li>
                )}
                {items.map((item) => (
                    <li
                        key={`${item._kind}-${item._id}`}
                        className={`list-group-item d-flex align-items-start gap-2${!item.read ? ' fw-semibold' : ''}`}
                    >
                        <span className="mt-1" title={item._kind === 'broadcast' ? 'Broadcast' : 'Notification'}>
                            {item._kind === 'broadcast' ? '📢' : '🔔'}
                        </span>
                        <div className="me-auto" style={{ minWidth: 0 }}>
                            <div className={item.read ? 'text-muted' : ''}>{item.title}</div>
                            {item.body && (
                                <div className="text-muted small text-truncate">{item.body}</div>
                            )}
                            {item.link && (
                                <div className="mt-1">
                                    <Link to={item.link} className="small">Open →</Link>
                                </div>
                            )}
                            <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                                {moment(item._date).fromNow()}
                            </div>
                        </div>
                        {!item.read && (
                            <button
                                className="btn btn-sm btn-outline-secondary flex-shrink-0"
                                style={{ fontSize: '0.7rem', padding: '2px 6px' }}
                                onClick={() => markRead.mutate({ kind: item._kind, id: item._id })}
                            >
                                ✓
                            </button>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}
